module.exports = __webpack_public_path__ + "static/Tareq-56dfd84075516ae39010cdedc93b8b1e.jpeg";